import { UiWrapper } from '@coinscrap/webapp-core';
import commonStyles from './commonStyles';

UiWrapper.defineComponent('enfatize', {
  styles: {
    default: {},
    ...commonStyles.styles,
  },
});
